// extracted by mini-css-extract-plugin
export default {"card":"TaskNotification_card__e8Dhn","task-button":"TaskNotification_task-button__NUs4y","notification-list":"TaskNotification_notification-list__ikZKT"};